( function( $ ) {
	'use strict';

	$( document ).ready( function() {
		list_block_tab.init();
	} );

	var list_block_tab = window.list_block_tab = {

		data: {},
		init: function() {
			this.nav_tabs();
		},

		nav_tabs: function() {
			var $sc = $( '.thim-block-tabs' );
			if ($sc.length == 0) {
				return;
			}
			$sc.on( 'click', '.nav-tabs a', function( e ) {
				e.preventDefault();
				$sc = $( this ).parents( '.thim-block-tabs' );
				var current_cat = $sc.find( '.nav-tabs .cat-item.active a' ).attr( 'data-cat' );
				$sc.find( '.nav-tabs li' ).removeClass( 'active' );
				$( this ).parents( 'li' ).addClass( 'active' );

				var params = $sc.attr( 'data-params' ),
					category = $( this ).attr( 'data-cat' ),
					sc_id = $sc.attr( 'id' );

				var data = {
					action: 'thim_load_content',
					category: category,
					params: params,
				};

				list_block_tab.data[sc_id + current_cat] = $sc.find( '.loop-wrapper' ).html();

				$sc.find( '.loop-wrapper' ).removeClass( 'fadeIn' );

				if (list_block_tab.data[sc_id + category]) {
					setTimeout( function() {
						$sc.find( '.loop-wrapper' ).html( list_block_tab.data[sc_id + category] );
						$sc.find( '.loop-wrapper' ).addClass( 'fadeIn' );
					}, 300 );
				} else {
					$.ajax( {
						type: 'POST',
						url: ekits_script.ajax_url,
						data: data,
						beforeSend: function() {
							$sc.addClass( 'loading' );
						},
						success: function( res ) {
							if (res.success) {
								$sc.find( '.loop-wrapper' ).html( res.data );
								$sc.find( '.loop-wrapper' ).addClass( 'fadeIn' );
							}
							$sc.removeClass( 'loading' );

						},
						error: function( xhr, status ) {
							alert( xhr.statusText );
						},
					} );
				}

			} );
		},
	};
} )( jQuery );
